const QuestStructure = [
  {
    id: 1,
    name: 'Quest Gampang',
    description: 'Quest ini gampang banget',
    xp: 5,
    difficulty: 1,
    subQuest: [
      {
        id: 1,
        name: 'Mudah',
        difficulty: 1,
      },
      {
        id: 2,
        name: 'Gampang',
        difficulty: 1,
      },
      {
        id: 3,
        name: 'Easy',
        difficulty: 1,
      },
    ]
  },
  {
    id: 2,
    name: 'Harta, Harta, Harta',
    description: 'Gunakan blok yang tepat untuk mencapai titik finis dengan harta sebanyak-banyaknya',
    xp: 25,
    difficulty: 1.6,
    subQuest: [
      {
        id: 1,
        name: 'Lead the Way 1',
        difficulty: 1,
      },
      {
        id: 2,
        name: 'Lead the Way 2',
        difficulty: 2,
      },
      {
        id: 3,
        name: 'Lead the Way 3',
        difficulty: 2,
      },
    ]
  },
  {
    id: 3,
    name: 'Lorem ipsum lagi',
    description: 'Lorem ipsum dolor sit amet',
    xp: 7,
    difficulty: 1.3,
    subQuest: [
      {
        id: 1,
        name: 'Dolor',
        difficulty: 1,
      },
      {
        id: 2,
        name: 'Sit',
        difficulty: 1,
      },
      {
        id: 3,
        name: 'Amet',
        difficulty: 2,
      },
    ]
  },
]

export default QuestStructure
